import { useMemo } from 'react';

import menuItems from 'config/menu';
import userRole from 'config/userRole';

import useAuth from 'hooks/useAuth';

// @deprecated
// in favor of feature toggles
// const filterTestOnlyItems = (items) => {
//   return Object.keys(items).reduce((acc, key) => {
//     if (!items[key].isTestOnly) {
//       if (items[key].items !== undefined) {
//         items[key].items = filterTestOnlyItems(items[key].items);
//       }
//       acc[key] = items[key];
//     }
//     return acc;
//   }, {});
// };

const useMainMenu = () => {
  const auth = useAuth();

  const items = useMemo(() => {
    if (auth.state.isLoading) {
      return {};
    }
    const { currentUser } = auth.state;
    const items = { ...menuItems };

    if (currentUser.role !== userRole.ADMIN) {
      delete items.admin;
    }

    if (currentUser.role === userRole.AGENCY) {
      // todo: find a better approach to this
      delete items.dashboard;
      delete items.alerts;
      delete items.loads;
      delete items.unloads;
      const individualStatsItem = { ...items.individuals.items.stats };
      individualStatsItem.icon = items.individuals.icon;
      items.individuals = individualStatsItem;
    }

    if (currentUser.username) {
      items.account.label = currentUser.username;
    }

    return items;
  }, [auth.state]);

  const byPath = useMemo(() => {
    const itemsByPath = {};
    let unvisited = Object.entries(items);

    do {
      let newPairs = [];
      unvisited.forEach(([key, item]) => {
        if (item.to) {
          itemsByPath[item.to] = key;
        } else if (item.items) {
          const subItems = Object.entries(item.items).map(item => [
            [key, item[0]].join('.'),
            item[1]
          ]);
          newPairs = newPairs.concat(subItems);
        }
      });
      unvisited = newPairs;
    } while (unvisited.length > 0);

    return itemsByPath;
  }, [items]);

  return {
    items,
    byPath,
  };
};

export default useMainMenu;